import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F7F5F0]/85 backdrop-blur-md border-b border-[#15243D]/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-brand"
          className="serif text-xl tracking-[0.3em] text-[#15243D]"
          style={{ fontWeight: 400 }}
        >
          ANCHOR
        </Link>

        <div className="hidden md:flex items-center gap-10 text-sm font-light text-[#15243D]">
          {location.pathname === "/" && (
            <>
              <a
                href="#philosophy"
                data-testid="nav-philosophy"
                className="hover:text-[#C07865] transition-colors"
              >
                Philosophy
              </a>
              <a
                href="#meet-ben"
                data-testid="nav-meet-ben"
                className="hover:text-[#C07865] transition-colors"
              >
                Meet Ben
              </a>
              <Link
                to="/story"
                data-testid="nav-story"
                className="hover:text-[#C07865] transition-colors"
              >
                Story
              </Link>
              <a
                href="#coaching"
                data-testid="nav-coaching"
                className="hover:text-[#C07865] transition-colors"
              >
                Coaching
              </a>
              <a
                href="#program"
                data-testid="nav-program-section"
                className="hover:text-[#C07865] transition-colors"
              >
                28-Day Program
              </a>
              <a
                href="#contact"
                data-testid="nav-contact"
                className="hover:text-[#C07865] transition-colors"
              >
                Contact
              </a>
            </>
          )}
          {location.pathname !== "/" && (
            <>
              <Link
                to="/"
                data-testid="nav-home"
                className="hover:text-[#C07865] transition-colors"
              >
                Home
              </Link>
              <Link
                to="/program"
                data-testid="nav-program"
                className="hover:text-[#C07865] transition-colors"
              >
                28-Day Program
              </Link>
            </>
          )}
          <Link
            to="/apply"
            data-testid="nav-apply"
            className="btn-primary"
            style={{ padding: "0.7rem 1.5rem", fontSize: "0.75rem" }}
          >
            Apply
          </Link>
        </div>

        {/* Mobile minimal: just Apply link */}
        <Link
          to="/apply"
          data-testid="nav-apply-mobile"
          className="md:hidden btn-primary"
          style={{ padding: "0.6rem 1.2rem", fontSize: "0.7rem" }}
        >
          Apply
        </Link>
      </div>
    </nav>
  );
}
